import { Text } from "../../components";
import { HTMLAttributes, useMemo } from "react";
import { twMerge } from "tailwind-merge";

interface Props extends HTMLAttributes<HTMLDivElement> {
  type?: string;
  label?: string;
  rules?: { required?: boolean }[];
  onSearch?: (value: string) => void;
}

const InputLayout = ({
  label = "",
  children,
  rules,
  id,
  type,
  className = "",
  ...props
}: Props) => {
  const isRequired = useMemo(
    () => !!(rules ?? []).filter((_) => _.required)?.length,
    [rules],
  );
  const isSearch = type === "search";

  return (
    <div {...props} className={twMerge("app-field w-full", className)}>
      {!!label && (
        <label htmlFor={id}>
          <Text
            weight={600}
            size="1.5rem"
            lineHeight="2.2rem"
            color="secondary"
            className="!mb-[0.6rem]"
            children={`${label}${isRequired ? "*" : ""}`}
          />
        </label>
      )}
      <div
        className={twMerge(
          "group rounded-card border-[length:var(--border-width)] border-solid border-[var(--color-border)] bg-white px-[1.4rem] py-[1rem] shadow-none transition-[border-color,box-shadow] duration-200 ease-out",
          "focus-within:border-primary focus-within:shadow-none",
          "[&_.ant-input]:w-full [&_.ant-input]:!min-h-0 [&_.ant-input]:!rounded-none [&_.ant-input]:!border-0 [&_.ant-input]:!bg-transparent [&_.ant-input]:!p-0 [&_.ant-input]:!text-[1.6rem] [&_.ant-input]:!leading-[2.4rem] [&_.ant-input]:!text-secondary [&_.ant-input]:!shadow-none [&_.ant-input]:!outline-none",
          "[&_.ant-input::placeholder]:!text-black/35",
          "[&_.ant-input-affix-wrapper]:!w-full [&_.ant-input-affix-wrapper]:!rounded-none [&_.ant-input-affix-wrapper]:!border-0 [&_.ant-input-affix-wrapper]:!bg-transparent [&_.ant-input-affix-wrapper]:!p-0 [&_.ant-input-affix-wrapper]:!shadow-none",
          "[&_.ant-input-group-addon]:!rounded-none",
          "[&_.ant-input-prefix]:!me-[1rem] [&_.ant-input-prefix]:text-[1.8rem] [&_.ant-input-prefix]:text-black/35 [&_.ant-input-prefix]:transition-colors [&_.ant-input-prefix]:duration-200",
          "focus-within:[&_.ant-input-prefix]:!text-primary",
          "[&_.ant-input-clear-icon]:!text-[1.8rem] [&_.ant-input-clear-icon]:!text-primary",
          "[&_.ant-input-password-icon]:text-[1.6rem] [&_.ant-input-password-icon]:text-black/40",
          "[&_textarea]:!min-h-[9.6rem] [&_textarea]:!resize-y [&_textarea]:!border-0 [&_textarea]:!bg-transparent [&_textarea]:!p-0 [&_textarea]:!text-[1.6rem] [&_textarea]:!leading-[1.5] [&_textarea]:!shadow-none",
          "[&_.ant-select]:w-full [&_.ant-select-selector]:!border-0 [&_.ant-select-selector]:!bg-transparent [&_.ant-select-selector]:!p-0 [&_.ant-select-selector]:!shadow-none",
          isSearch &&
            "flex items-center !rounded-full border-[var(--color-border)] bg-[#fafafa] px-[1.8rem] py-[1.2rem] shadow-[0_10px_28px_rgba(17,17,17,0.07)] hover:bg-white focus-within:bg-white",
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default InputLayout;
